import _objectSpread from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import e from "../../TimeExtent.js";
import r from "../../geometry/Extent.js";
import i from "../../geometry/SpatialReference.js";
import { w as n } from "../../chunks/persistableUrlUtils.js";
import { toLocalTimeExtent as t, toUTCTimeExtent as o } from "../../support/timeUtils.js";
import a from "../../symbols/support/ElevationInfo.js";
import { transparencyToOpacity as s } from "../../webdoc/support/opacityUtils.js";
var l = {
  type: Boolean,
  value: !0,
  json: {
    origins: {
      service: {
        read: !1,
        write: !1
      },
      "web-map": {
        read: !1,
        write: !1
      }
    },
    name: "screenSizePerspective",
    write: !0
  }
},
    p = {
  type: Boolean,
  value: !0,
  json: {
    name: "disablePopup",
    read: {
      reader: function reader(e, r) {
        return !r.disablePopup;
      }
    },
    write: {
      enabled: !0,
      writer: function writer(e, r, i) {
        r[i] = !e;
      }
    }
  }
},
    m = {
  type: Boolean,
  value: !0,
  json: {
    name: "showLabels",
    write: !0
  }
},
    f = {
  type: String,
  json: {
    origins: {
      "portal-item": {
        write: !1
      }
    },
    write: {
      isRequired: !0,
      ignoreOrigin: !0,
      writer: n
    }
  }
},
    c = {
  type: Boolean,
  value: !0,
  json: {
    origins: {
      service: {
        read: {
          enabled: !1
        }
      }
    },
    name: "showLegend",
    write: !0
  }
},
    d = {
  value: null,
  type: a,
  json: {
    origins: {
      service: {
        name: "elevationInfo",
        write: !0
      }
    },
    name: "layerDefinition.elevationInfo",
    write: !0
  }
};

function y(e) {
  return {
    type: e,
    readOnly: !0,
    json: {
      origins: {
        service: {
          read: !0
        }
      },
      read: !1
    }
  };
}

var u = {
  type: Number,
  json: {
    origins: {
      "web-document": {
        write: !0,
        read: !0
      },
      "portal-item": {
        write: !0
      }
    }
  }
},
    w = _objectSpread(_objectSpread({}, u), {}, {
  json: _objectSpread(_objectSpread({}, u.json), {}, {
    origins: {
      "web-document": _objectSpread(_objectSpread({}, u.json.origins["web-document"]), {}, {
        write: {
          enabled: !0,
          target: {
            opacity: {
              type: Number
            },
            "layerDefinition.drawingInfo.transparency": {
              type: Number
            }
          }
        }
      })
    },
    read: {
      source: ["layerDefinition.drawingInfo.transparency", "drawingInfo.transparency"],
      reader: function reader(e, r, i) {
        return i && "service" !== i.origin || !r.drawingInfo || void 0 === r.drawingInfo.transparency ? r.layerDefinition && r.layerDefinition.drawingInfo && void 0 !== r.layerDefinition.drawingInfo.transparency ? s(r.layerDefinition.drawingInfo.transparency) : void 0 : s(r.drawingInfo.transparency);
      }
    }
  })
}),
    g = {
  type: e,
  readOnly: !0,
  get: function get() {
    var e, r;
    if (null == (e = this.layer) || !e.timeInfo) return null;
    var _this$layer = this.layer,
        i = _this$layer.datesInUnknownTimezone,
        n = _this$layer.timeOffset,
        a = _this$layer.useViewTime,
        s = null == (r = this.view) ? void 0 : r.timeExtent;
    var l = this.layer.timeExtent;
    i && (l = t(l));
    var p = a ? s && l ? s.intersection(l) : s || l : l;
    if (!p || p.isEmpty || p.isAllTime) return p;
    n && (p = p.offset(-n.value, n.unit)), i && (p = o(p));

    var m = this._get("timeExtent");

    return p.equals(m) ? m : p;
  }
},
    v = {
  type: r,
  readOnly: !0,
  json: {
    origins: {
      service: {
        read: {
          source: ["fullExtent", "spatialReference"],
          reader: function reader(e, n) {
            var t = r.fromJSON(e);
            return null != n.spatialReference && "object" == typeof n.spatialReference && (t.spatialReference = i.fromJSON(n.spatialReference)), t;
          }
        }
      }
    },
    read: !1
  }
},
    j = {
  type: String,
  json: {
    origins: {
      service: {
        read: !1
      },
      "portal-item": {
        read: !1
      }
    }
  }
},
    b = {
  type: Number,
  json: {
    origins: {
      service: {
        write: {
          enabled: !1
        }
      }
    },
    read: {
      source: "layerDefinition.minScale"
    },
    write: {
      target: "layerDefinition.minScale"
    }
  }
},
    I = {
  type: Number,
  json: {
    origins: {
      service: {
        write: {
          enabled: !1
        }
      }
    },
    read: {
      source: "layerDefinition.maxScale"
    },
    write: {
      target: "layerDefinition.maxScale"
    }
  }
};

export { g as combinedViewLayerTimeExtentProperty, d as elevationInfo, j as id, m as labelsVisible, c as legendEnabled, I as maxScale, b as minScale, u as opacity, w as opacityDrawingInfo, p as popupEnabled, y as readOnlyService, v as sceneLayerFullExtent, l as screenSizePerspectiveEnabled, f as url };